import React from "react";
import { createPortal } from "react-dom";

const SettingsModal = ({
  title,
  description,
  children,
  onClose,
  panelClassName = "",
  bodyClassName = "",
  variant = "default",
}: {
  title: string;
  description: string;
  children: React.ReactNode;
  onClose: () => void;
  panelClassName?: string;
  bodyClassName?: string;
  variant?: "default" | "automatedEmail";
}) => {
  const emailEditor = variant === "automatedEmail";
  const hasCustomMaxWidth = panelClassName.includes("max-w-");

  const modalContent = (
    <div className={`fixed inset-0 z-[9999] flex items-center justify-center bg-black/45 ${emailEditor ? "p-[24px]" : "p-4"}`}>
      <div
        role="dialog"
        aria-modal="true"
        className={`${emailEditor ? "relative max-h-[90vh]" : "max-h-[calc(100vh-2rem)]"} w-full ${
          hasCustomMaxWidth ? "" : "max-w-xl"
        } overflow-y-auto bg-white ${emailEditor ? "rounded-[14px] px-[32px] py-[30px] leading-[normal] shadow-[0_18px_48px_rgba(0,0,0,.18)]" : "rounded-lg border border-gray-200 p-6 shadow-xl"} ${panelClassName}`}
      >
        <div className="flex items-start justify-between gap-4">
          <div>
            <h3 className={emailEditor ? "pr-[14px] text-[18px] font-bold leading-[24px] text-[#0A0A0A]" : "text-lg font-bold text-black"}>{title}</h3>
            {description && <p className="mt-1 text-sm leading-6 text-black">{description}</p>}
          </div>
          <button
            type="button"
            onClick={onClose}
            className={emailEditor ? "absolute right-[14px] top-[14px] flex h-[28px] w-[28px] items-center justify-center rounded-full border-0 bg-[#F21B1B] text-white" : "flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-gray-200 text-sm font-bold text-gray-500 transition hover:bg-gray-100 hover:text-gray-700 focus:outline-none focus:ring-0 focus-visible:outline-none focus-visible:ring-0"}
            aria-label="Close modal"
          >
            {emailEditor ? <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round"><path d="m6 6 12 12M18 6 6 18" /></svg> : "X"}
          </button>
        </div>
        <div className={`${emailEditor ? "mt-[16px]" : "mt-5"} ${bodyClassName}`}>{children}</div>
      </div>
    </div>
  );

  if (typeof document === "undefined") {
    return modalContent;
  }

  return createPortal(modalContent, document.body);
};

export default SettingsModal;
